module.exports = __webpack_public_path__ + "img/maasmechelen.4a5a0b7c.jpg";